<p class="form-link-and-text">
    <span class="ds-text-link" (click)="onClick()">{{field.templateOptions.sectionHeading}}</span> 
    @if(userType==5 && count==0){<span class="error-text"> {{'no_forms_selected' | translate }}</span>}
    @if(userType==5 && count>0){<span class="secondary-text"> {{count}} {{'forms_required' | translate }}</span>}
</p>